import { useQueryClient } from '@tanstack/react-query';
import { accountSummaryV2CacheKey } from '@syf-api-library/account-summary';
import { Flows, Routes } from '../const';
import { useMainContext } from '../context';
import usePrimaryAction from './use-primary-action';
import useSecondaryAction from './use-secondary-action';
var useModalActions = function (setModal, flow, navigateTo, accountId) {
    var _a = useMainContext(), currentRoute = _a.currentRoute, setCurrentRoute = _a.setCurrentRoute;
    var queryClient = useQueryClient();
    var onTransitionEnd = function () {
        flow.onResetQuestionnaire();
        if (currentRoute.includes(Flows.SETTLEMENT))
            flow.setPlan(null);
        setCurrentRoute(Routes.PAYMENT_OPTIONS);
    };
    var handleCloseModal = function () {
        setModal('', '');
        queryClient.invalidateQueries({
            queryKey: accountSummaryV2CacheKey({
                accountId: accountId || '',
                accountIdType: 'guid'
            })
        });
        var modalElement = document.getElementById('other-options');
        modalElement === null || modalElement === void 0 ? void 0 : modalElement.addEventListener('transitionend', onTransitionEnd);
        modalElement === null || modalElement === void 0 ? void 0 : modalElement.addEventListener('transitioncancel', onTransitionEnd);
    };
    var getPrimaryAction = usePrimaryAction(flow, {
        handleCloseModal: handleCloseModal,
        onTransitionEnd: onTransitionEnd,
        navigateTo: navigateTo,
        setModal: setModal
    });
    var getSecondaryAction = useSecondaryAction(flow, {
        handleCloseModal: handleCloseModal,
        navigateTo: navigateTo
    });
    return {
        handleCloseModal: handleCloseModal,
        getPrimaryAction: getPrimaryAction,
        getSecondaryAction: getSecondaryAction
    };
};
export default useModalActions;
//# sourceMappingURL=use-modal-actions.js.map